$(document).ready(function() {
    $(document).on('click', '.timeline .link-more', function(e){
        e.preventDefault();
        var currentTimestamp = $(this).attr('data-month'),
            locationId = $(this).attr('data-location-id'),
            category = $(this).attr('data-filter'),
            urlRoute = Routing.generate("ojd_search_event_nextItem",{
                'locationId': locationId,
                'month': currentTimestamp,
                'category': category
        });
        $('.bloc-loading').show();
        $.ajax({
            url : urlRoute,
            method: 'POST',
            dataType: "json",
            success: function ( response ) {
                $('.bloc-loading').hide();
                $('.more-info').before(response.result);
                $('.link-more').attr('data-month', response.nextMonth);
            },
            error: function () {
                alert('erreur !!');
            }
        });
    });

});